// Product Item Cards

var product_item_cards = document.getElementsByClassName("snippet-product-item");
var article_item_cards = document.getElementsByClassName("snippet-article-item");

var open_product_link = function() {
    var product_url = this.getAttribute("data-product-url");
    //window.open(product_url, '_self')
    //console.log(product_url.length);
    if (product_url && product_url.length > 0) {
      window.open(product_url, '_self')
    }
    //console.log(product_url);
};

var open_article_link = function() {
    var article_url = this.getAttribute("data-article-url");
    if (article_url && article_url.length > 0) {
      window.open(article_url, '_self')
    }
};

for (var i = 0; i < product_item_cards.length; i++) {
    product_item_cards[i].addEventListener('click', open_product_link, false);
}

for (var i = 0; i < article_item_cards.length; i++) {
    article_item_cards[i].addEventListener('click', open_article_link, false);
}

// contact us links, working with Buddha menu restirctions
// document.querySelectorAll("a[data-href='/pages/contact']").forEach(contact_us_link => contact_us_link.classList.add("hs-cta-trigger-button"));
// document.querySelectorAll("a[data-href='/pages/contact']").forEach(contact_us_link => contact_us_link.classList.add("hs-cta-trigger-button-154165929735"));
// document.querySelectorAll("a[data-href='/pages/contact']").forEach(contact_us_link => contact_us_link.classList.add("hs-cta-trigger-button-154165929735"));

if (window.location.href.includes('/products/') || window.location.href.includes('/products_preview')) {
  var quantity_field = document.getElementById("product-form-quantity");
  var varient_field = document.getElementById("product-form-option-1");
  var total_field = document.getElementById("template-product__price-dynamic-change");
  var update_total_html = function(){
      if (varient_field) {
          var selected_varient_price = varient_field.selectedOptions[0].dataset.price_number,
              selected_varient_currency = varient_field.selectedOptions[0].dataset.price_currency;      
      } else {
          var selected_varient_price = document.getElementById("product-price").dataset.price_number,
              selected_varient_currency = document.getElementById("product-price").dataset.price_currency;       
      }
      var selected_quanity = quantity_field.value;
      if (selected_varient_price > 0) {
        // console.log(selected_varient_price);
        // console.log(selected_quanity);
        // console.log(selected_varient_price * selected_quanity);
        // console.log(selected_varient_currency + calculated_total.toFixed(2));
        var calculated_total = (selected_varient_price * selected_quanity) / 100;  
        total_field.innerHTML = selected_varient_currency + calculated_total.toFixed(2);
      }
  }
  if (quantity_field) {
    quantity_field.addEventListener('change', update_total_html) 
  }
  if (varient_field) {
    varient_field.addEventListener('change', update_total_html)
  };
  // Turf pegs calculator
  var turf_area_field = document.getElementById("turf-area"),
      turf_pegs_field = document.getElementById("turf-pegs"),
      calc_turf_area = function() {
        turf_pegs = Math.ceil(
          (turf_area_field.value / 0.6)
        ) * 3;
        turf_pegs_field.value = turf_pegs;
      }
  if (turf_area_field) {
    turf_area_field.addEventListener('change', calc_turf_area) 
  }
  
}

// All projects page

if (window.location.href.includes('projects')) {
  
  var grid_item = document.getElementsByClassName("grid-item");
  var tag_search_link = document.getElementsByClassName("project-tag");
  var search_for_tag = function(tag_name) {
    if (tag_name != '' & tag_name != 'all') {
      for (var i = 0; i < grid_item.length; i++) {
          if (grid_item[i].dataset[tag_name]){
            grid_item[i].classList.remove("hidden")
          } else {
            grid_item[i].classList.add("hidden")
          }
      }
    } else {
      // show all
      for (var i = 0; i < grid_item.length; i++) {
          grid_item[i].classList.remove("hidden")
      }
    }
    // highlight category
    for (var i = 0; i < tag_search_link.length; i++) {
          if (tag_search_link[i].dataset["tag"] == tag_name) {
             tag_search_link[i].classList.add("selected")  
          } else {
            tag_search_link[i].classList.remove("selected") 
          }
      }
  };

  for (var i = 0; i < tag_search_link.length; i++) {
      let this_tag = tag_search_link[i].dataset["tag"];
      tag_search_link[i].addEventListener('click', function() {
        search_for_tag(this_tag) 
      });
  }

}


// Hero banner slider

var swiper = new Swiper(".hero-banner-slider.header", {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: true
    },
    loop: true,
    loopedSlides: document.querySelectorAll('.hero-banner-slider.header .swiper-slide').length,
    speed: 1200,
    watchSlidesProgress: false,  
    // effect: 'fade',
    // fadeEffect: { 
    //   crossFade: true 
    // }
});


// Featured case study

var swiper = new Swiper(".featured-case-study .swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1200,
    watchSlidesProgress: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // effect: 'fade',
    // fadeEffect: { 
    //   crossFade: true 
    // }
});

var swiper = new Swiper(".image-ss .swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1200,
    watchSlidesProgress: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    // effect: 'fade',
    // fadeEffect: { 
    //   crossFade: true 
    // }
});


// Featured-sliders

var feautured_sliders = document.getElementsByClassName("swiper-container");

var auto_play_slider = function(this_slider) {
  setInterval(function(){
    this_slider.swiper.slideNext();
  }, 5000); 
}

for (var i = 0; i < feautured_sliders.length; i++) {
    if (feautured_sliders[i].classList.contains('auto-play')) {
      auto_play_slider(feautured_sliders[i])
    }
}

// Project-sliders

var swiper = new Swiper(".swiper-container.projects-slider", {
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1200,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


// Project-sliders

var swiper = new Swiper(".swiper-container.product-image-slider", {
    // spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1200,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

// Video-sliders

var swiper = new Swiper(".video-slider", {
    // spaceBetween: 30,
    // centeredSlides: true,
    // autoplay: {},
    initialSlide: 0,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

